export const visit = (vm, at) => {
at({ "da": { "uiAddonTeams": { "teamSelectLabelOne": "1 team valgt", "teamSelectLabelMany": "{{ count }} teams valgt", "selectTeams": "V\xE6lg teams", "selectAll": "V\xE6lg alle ({{ teamName }})" } } });
};